<p-toast></p-toast>
<p-panel header="Bounds">
  <ng-template #icons>
    <div class="flex gap-2">

      <!-- Add Button -->
      <p-button icon="pi pi-plus" label="Add" severity="primary" (onClick)="addNew()" [disabled]="loading()" outlined>
      </p-button>

      <!-- Edit Button -->
      <p-button icon="pi pi-pencil" label="Edit" severity="secondary" (onClick)="editBound()"
        [disabled]="selectedBounds().length !== 1 || loading()" outlined>
      </p-button>

      <!-- Delete Button -->
      <p-button icon="pi pi-trash" [label]="deleteButtonLabel()" severity="danger" (onClick)="deleteBound()"
        [disabled]="selectedBounds().length === 0 || loading()" outlined>
      </p-button>

      <!-- Refresh Button -->
      <p-button icon="pi pi-refresh" label="Refresh" severity="secondary" (onClick)="refreshBounds()"
        [disabled]="loading()" outlined>
      </p-button>

      <!-- History Button -->
      <p-button icon="pi pi-history" label="History" severity="secondary" (onClick)="showHistory()"
        [disabled]="loading() || selectedBounds().length !== 1" outlined>
      </p-button>
    </div>
  </ng-template>
  <ng-template #content>
    <!-- Search Panel -->
    <div class="mb-4 p-4 bg-surface-50 rounded-lg border border-surface-200">
      <div class="mb-3">
        <label for="boundSearch" class="block text-sm font-medium text-surface-700 mb-1">Search by Bound Name or Bound
          Code</label>
        <div class="flex items-center gap-2">
          <div class="flex-1">
            <p-iconfield iconPosition="left">
              <p-inputicon>
                <i class="pi pi-search"></i>
              </p-inputicon>
              <input id="boundSearch" pInputText type="text" [(ngModel)]="keywords" (ngModelChange)="onFilter($event)"
                placeholder="Enter search terms..." autocomplete="off" />
            </p-iconfield>
          </div>
          <p-button *ngIf="keywords.trim()" icon="pi pi-times" label="Clear Search" severity="secondary" size="small"
            (onClick)="clearFilter()" outlined>
          </p-button>
        </div>
      </div>

    </div>

    <p-divider></p-divider>
    <p-table [value]="(bounds() || [])" [totalRecords]="(totalRecords() || 0)" [paginator]="true" [rows]="rows"
      [first]="first" [lazy]="true" [loading]="loading()" [loadingIcon]="'pi pi-spin pi-cog'"
      [tableStyle]="{ 'min-width': '30rem' }" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} bounds" paginatorDropdownAppendTo="body" [rowsPerPageOptions]="[10, 25, 50]"
      (onPage)="onPage($event)" selectionMode="multiple" [(selection)]="selectedBounds"
      (selectionChange)="selectedBounds.set($event)" dataKey="id" size="small">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th>Bound Name</th>
          <th>Bound Code</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-bound>
        <tr [pSelectableRow]="bound">
          <td>
            <p-tableCheckbox [value]="bound"></p-tableCheckbox>
          </td>
          <td>{{ bound.bound_name }}</td>
          <td>{{ bound.bound_code }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" class="text-center p-4">No bounds found</td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-panel>

<p-confirmDialog></p-confirmDialog>

<p-dialog [visible]="dialogVisible()" (visibleChange)="dialogVisible.set($event)" [modal]="true" [draggable]="false"
  [resizable]="false" [closable]="false" [dismissableMask]="true" [closeOnEscape]="true" [style]="{width: '450px'}">
  <ng-template #header>
    <h3 class="text-lg font-medium text-surface-900">{{ isEditMode() ? 'Edit Bound' : 'Add Bound' }}</h3>
  </ng-template>

  <div class="mb-4 mt-2 flex items-center gap-4">
    <div class="flex flex-col gap-2">
      <label for="boundName" class="font-medium">Bound Name</label>
      <input id="boundName" type="text" pInputText [ngModel]="boundName()" (ngModelChange)="boundName.set($event)"
        placeholder="Enter bound name" class="w-full">
    </div>
  </div>

  <div class="mb-4 mt-2 flex items-center gap-4">
    <div class="flex flex-col gap-2">
      <label for="boundCode" class="font-medium">Bound Code</label>
      <input id="boundCode" type="text" pInputText [ngModel]="boundCode()" (ngModelChange)="boundCode.set($event)"
        placeholder="Enter bound code" class="w-full">
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Cancel" icon="pi pi-times" (onClick)="closeDialog()" [disabled]="savingBound()"
      styleClass="p-button-text">
    </p-button>
    <p-button [label]="isEditMode() ? 'Update' : 'Save'" icon="pi pi-check" (onClick)="saveBound()"
      [disabled]="savingBound()" [loading]="savingBound()">
    </p-button>
  </ng-template>
</p-dialog>

<app-asset-history-dialog
  [(visible)]="historyVisible"
  [resourceName]="auditResourceName"
  [recordId]="historyRecordId"
  [recordLabel]="historyRecordLabel">
</app-asset-history-dialog>
